import {mapGetters} from 'vuex';
import {configTables} from "../../../global/configTables.js";
import {api} from "../../../global/framework/api.js";
import {formatter} from "../../../global/formatter.js";
import {searchCriteriaMixin} from "./searchCriteriaMixin.js";
import _ from "lodash";

export const searchFiltersMixin = {
	props: {
		radiusId: {type: [Number], required: true},
		// Optional: member/PSR use consumerId; enrollment uses companyId + token (BaseSearchBoxV2.html)
		consumerId: {type: [Number], default: null},
		companyId: {type: [Number], default: null},
		token: {type: [String], default: null},
	},
	data() {
		return {
			searchRadiusOptions: [],
			professionalDesignations: [],
			availableNetworks: [],
		};
	},
	mixins: [searchCriteriaMixin],
	methods: {
		shouldRunSearch() {
			const requiresPlanCategorySelection = Boolean(this.consumerId);
			const hasSelectedCategory = this.searchCriteria.planCategoryId !== null
				&& typeof this.searchCriteria.planCategoryId !== 'undefined'
				&& this.searchCriteria.planCategoryId !== '';
			return this.hasSearchCriteria && (!requiresPlanCategorySelection || hasSelectedCategory);
		},
		async filterInit() {
			await Promise.all([this.baseLoad(), this.setCurrentCriteria()]);
			if (this.shouldRunSearch()) {
				await this.$store.dispatch("SEARCH_PHYSICIANS", {
					searchCriteria: this.searchCriteria,
					baseUrl: this.generateBaseUrl()
				});
			}
		},
		async baseLoad() {
			let [radius, designations] = await Promise.all([configTables.getSearchRadiusOptions(),
				configTables.getProfessionalDesignations()
			]);
			this.searchRadiusOptions = radius;
			this.professionalDesignations = designations;
		},
	}
};